import { render, staticRenderFns } from "./TheAlert.vue?vue&type=template&id=58b57224&scoped=true&"
import script from "./TheAlert.vue?vue&type=script&lang=js&"
export * from "./TheAlert.vue?vue&type=script&lang=js&"
import style0 from "./TheAlert.vue?vue&type=style&index=0&id=58b57224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b57224",
  null
  
)

export default component.exports